var Admin = function () { return import('~/pages/dashboard/admin.vue'); };
var TelAdmin = function () { return import('~/pages/dashboard/tel-admin.vue'); };
var VisitAdmin = function () { return import('~/pages/dashboard/visit-admin.vue'); };
var LegalAdmin = function () { return import('~/pages/dashboard/legal-admin.vue'); };
export default [
    {
        path: '/dashboard/admin',
        name: 'admin',
        title: '管理员首页',
        component: Admin
    },
    {
        path: '/dashboard/tel-admin',
        name: 'tel-admin',
        title: '电催员首页',
        component: TelAdmin
    },
    {
        path: '/dashboard/visit-admin',
        name: 'visit-admin',
        title: '外访员首页',
        component: VisitAdmin
    },
    {
        path: '/dashboard/legal-admin',
        name: 'legal-admin',
        title: '法务员首页',
        component: LegalAdmin
    },
];
